// CustomButtonRadio.tsx
import React from 'react';
import { ToggleButton, ToggleButtonGroup, Stack, Typography } from '@mui/material';

// Описываем структуру объекта опции
interface Option {
  value: number;
  label: string;
}

interface CustomButtonGroupProps {
  options: Option[];
  value: number;
  onChange: (value: number) => void;
  orientation?: 'horizontal' | 'vertical';
  label?: string;
}

const CustomButtonRadio: React.FC<CustomButtonGroupProps> = ({
  options,
  value,
  onChange,
  orientation = 'horizontal',
  label
}) => {
  
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newValue: string | null,
  ) => {
    // Проверка на null запрещает "отжатие" кнопки (всегда выбрано одно значение)
    if (newValue !== null) {
      onChange(Number(newValue));
    }
  };

  return (
    <Stack spacing={1} alignItems="flex-start">
      {label && <Typography variant="h6">{label}</Typography>}
      
      <ToggleButtonGroup
        value={String(value)}
        exclusive
        onChange={handleChange}
        orientation={orientation}
        color="primary"
        sx={{
            gap: 1,
            
            flexWrap: 'wrap', // РАЗРЕШАЕМ ПЕРЕНОС КНОПОК
            width: '100%',   // Растягиваем группу на всю доступную ширину

            // Убираем дефолтную склейку кнопок MUI
            '& .MuiToggleButtonGroup-grouped': {
            margin: 0,
            border: '1px solid rgba(0, 0, 0, 0.12) !important',
            borderRadius: '4px !important',
            // textTransform: 'none', // Чтобы текст не был капсом
            padding: '8px 16px',
            
            // СОСТОЯНИЕ: ВЫБРАНО
            '&.Mui-selected': {
                backgroundColor: '#1976d2 !important', // Явный синий цвет (primary.main)
                color: '#ffffff !important',          // Белый текст для контраста
                fontWeight: 'bold',
                '&:hover': {
                backgroundColor: '#1565c0 !important', // Чуть темнее при наведении
                },
            },

            // СОСТОЯНИЕ: НЕ ВЫБРАНО
            '&:not(.Mui-selected)': {
                backgroundColor: 'transparent',
                color: '#1976d2', // Текст цвета primary
                '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.04)', // Легкий оттенок при наведении
                },
            },
            },
        }}
        >
        {options.map((opt) => (
          <ToggleButton key={opt.value} value={String(opt.value)}>
            {opt.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};

export default CustomButtonRadio;